import { GameState } from '../objects/GameState';
import { Diagnosis } from '../objects/Diagnosis';
import { Helpers } from '../objects/Helpers';
import initializeInteractiveCursor from 'src/games/shared/InteractiveCursorUtil';
import TranslateApi from 'src/utils/TranslateHelper';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';

export class BacteriaInfoScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    correctDiagnosis: Diagnosis;

    constructor() {
        super({
            key: "BacteriaInfoScene_" + Math.random(),
        });
    }

    preload(): void {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("bacteria_info_scene_map", require("/src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_bacteria_info_scene.json"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'bacteria_info_scene_map' });
        this.correctDiagnosis = GameState.current.correctDiagnosis;
    }

    generateScene() {
        let background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);

        var notesBackground = this.add.image(100, 450, "pixel").setOrigin(0).setDisplaySize(225, 150).setTint(0x000000).setAlpha(0.7);

        this.addObjects();
        Helpers.addNextButton(this);
        Helpers.addBackButton(this);
    }

    addObjects(): void {
        var translateString = "Diagnosis.Phaser.BacteriaInfoScene.";
        var fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: "#ffffff" };
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "microscope") {
                var microscope = this.add.image(ob.x, ob.y, "assets", "microscope");
                microscope.setOrigin(0);
                microscope.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = TranslateApi.translate(translateString+"text");
                var box = this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(this.gameWidth/2 - box.displayWidth/2);
                this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "bacteria") {
                var bacteria = this.add.image(ob.x, ob.y, "assets", "temp_bacteria");
                bacteria.setOrigin(0);
                bacteria.setDisplaySize(ob.width, ob.height);
                bacteria.setTint(this.correctDiagnosis.bacteriaColor);
                var bacteriaBounds = bacteria.getTopRight();
                var labelText = TranslateApi.translate(translateString+"labelText");
                var bacteriaLabel = this.add.text(120, bacteriaBounds.y + bacteria.height / 2, labelText, fontStyle);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/scenes/BacteriaInfoScene.ts